angular.module('myApp.partner', ['ngRoute'])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/partner-with-us', {
            templateUrl: 'components/partner/partner.html',
            controller: 'partnerCtrl'
        })
    }])
    .controller('partnerCtrl', ['$scope','$rootScope','$window', '$timeout', 'API',function( $scope, $rootScope, $window, $timeout, API) {
        $window.scrollTo(0, 0);
        $scope.name="";
                       $scope.email="";
                         $scope.phoneNo="";
                      $scope.companyName="";
                    $scope.question="";
                    $scope.product="";
                    $scope.companySize="";
        
      
        $('.selectpicker').selectpicker({
		size: 5
	});
         
    
    $('#myFilter').change(function() {
		  $scope.product = $('.selectpicker').val();
         
    });
          
        
    
    $scope.register = function()
    {
      $("#myModal").modal("hide");
      $rootScope.loading_custom = true;
         
       // test  https://webapi-dev.clicklabs.in/ju/cta.php 
   
        API.post('https://webapi.clicklabs.in/ju/cta.php', {
			    name: $scope.name,
				email: $scope.email,
				phoneno: $scope.phoneNo,
				email: $scope.email,
			    autkey: "devAdmin8671",
				mycompany: $scope.companyName,
				your_question: $scope.question,
                products: $scope.product.toString(),
                companysize : $scope.companySize
		}).then(function (result) {
           $rootScope.loading_custom = false;
            if(result.data.message=="Success")
                
                {
                      
                    $("#SuccessModal").modal("show")
                      $scope.name="";
                       $scope.email="";
                        $scope.phoneNo="";
                      $scope.companyName="";
                    $scope.question="";
                    $scope.product="";
                    $scope.companySize="";
                    $scope.myForm.firstName.$touched=false;
                     $scope.myForm.email.$touched=false;
                     $scope.myForm.phnNo.$touched=false;
                    $scope.myForm.Company.$touched=false;
                    $scope.myForm.companySize.$touched=false;
                    
                }
            
        })
    }    
        
    }]);

    

   